import template from './sentqueries.html';
import controller from './sentqueries.controller';
import './sentqueries.styl';

let sentqueriesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default sentqueriesComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/sentqueries/sentqueries.component.js